module.exports = __webpack_public_path__ + "img/QTIndu.4c9d4e23.png";